import React from 'react';
import { Button } from 'components/text-editor/components/controls/components/markup-menu/style';
import { ReactComponent as DeleteIcon } from 'styles/icons/delete-icon.svg';
import { ReactComponent as DashedLink } from 'styles/icons/dashed-link-icon.svg';
import { ReactComponent as LinkIcon } from 'styles/icons/link-text.svg';

interface LinkingButtonProps {
  showFinishLinkAction?: boolean;
  showDeleteLinkAction?: boolean;
  isLinkButtonDisabled?: boolean;
  deleteLink: Function;
  startLinking: Function;
  finishLinking: Function;
}

export default function LinkingButtons({
  isLinkButtonDisabled,
  showDeleteLinkAction,
  showFinishLinkAction,
  startLinking,
  finishLinking,
  deleteLink,
}: LinkingButtonProps) {
  if (showDeleteLinkAction) {
    return (
      <Button danger onMouseDown={deleteLink} disabled={isLinkButtonDisabled}>
        <DeleteIcon />
      </Button>
    );
  }

  if (showFinishLinkAction) {
    return (
      <Button
        linking
        onMouseDown={finishLinking}
        disabled={isLinkButtonDisabled}>
        <DashedLink />
      </Button>
    );
  }

  return (
    <Button onMouseDown={startLinking} disabled={isLinkButtonDisabled}>
      <LinkIcon />
    </Button>
  );
}
